import Swiper from 'swiper';
import SwiperCore, {Navigation, Pagination, Autoplay} from 'swiper/core';
import album from '../components/album';

export default {
  init() {
  },
  finalize() {
    /**
     * Swiper
     */
    const initSwiper = () => {
      // configure Swiper to use modules
      SwiperCore.use([Navigation, Pagination, Autoplay]);

      const swiper = new Swiper('.swiper-container', {
        // Optional parameters
        autoplay: {
          delay: 5000,
        },
        direction: 'horizontal',
        loop: true,
        updateOnImagesReady: true,
        // If we need pagination
        pagination: {
          el: '.swiper-pagination',
          bulletClass: 'swiper-pagination-rect',
          bulletActiveClass: 'swiper-pagination-rect-active',
        },
      });

      swiper.on('afterInit', function () {
        window.dispatchEvent(new Event('resize'));
      });

      swiper.init();
    }

    /*
    Initialize
     */
    initSwiper();
    // Commons albums methods
    window.album_loadmore_params.editions = 'latest';
    album.init('latest');
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/templateLatestEdition.js